import { createActionGroup, props } from "@ngrx/store";
import { AppError } from "../../app-store-error.types";

// **************************************************************************
// DATA ACTIONS
// Note: Individual feature actions are in their respective folders
// This action group handles cross-cutting concerns (initialization, errors)
// **************************************************************************
export const DataActions = createActionGroup({
    source: "Data",
    events: {
        "Initialize Data": props<{ companyId: string }>(),
        "Initialize Data Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
